const stats = [
  { username: 'admin', password: 'admin', uuid: 'admin-uuid', name: '管理员' },
  { username: 'editor', password: 'editor', uuid: 'editor-uuid', name: '编辑' },
  { username: 'user1', password: 'user1', uuid: 'user1-uuid', name: '用户1' },
  { username: 'huashui', password: 'admin', uuid: 'admin-uuid', name: '晏鹏' }
]

export default [
  {
    path: '/api/stat/index',
    method: 'get',
    handle ({ body }) {
      return {
        code: 0,
        msg: '获取首页统计信息成功',
        data: {
          token: '8dfhassad0asdjwoeiruty'
        }
      }
    }
  }
]
